/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Clubs_Member_ActionsInputs */

const en_us2_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for ${i?.name}`)
};

const pt_br2_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ações para ${i?.name}`)
};

const es_419_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acciones para ${i?.name}`)
};

const pt_pt2_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ações para ${i?.name}`)
};

const fr_fr2_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions pour ${i?.name}`)
};

const de_de2_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktionen für ${i?.name}`)
};

const it_it2_clubs_member_actions = /** @type {(inputs: Clubs_Member_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Azioni per ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Actions for {name}" |
*
* @param {Clubs_Member_ActionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_member_actions = /** @type {((inputs: Clubs_Member_ActionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Member_ActionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_member_actions(inputs)
	if (locale === "es-419") return es_419_clubs_member_actions(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_member_actions(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_member_actions(inputs)
	if (locale === "de-DE") return de_de2_clubs_member_actions(inputs)
	if (locale === "it-IT") return it_it2_clubs_member_actions(inputs)
	return en_us2_clubs_member_actions(inputs)
});
export { clubs_member_actions as "clubs.member_actions" }